import { aigcAdvancedLimit } from '@op/services/aigc';
import { useEffect, useState } from 'react';
import { GptOptionsType } from '../types';

export default function useAdvancedSummary({
  defaultValue,
  needRequest = true,
  defaultLoading = false,
}: {
  defaultValue?: GptOptionsType;
  needRequest?: boolean;
  defaultLoading?: boolean;
}) {
  const [remainder, setRemainder] = useState(0);
  const [total, setTotal] = useState(200);
  const [gptOptions, setGptOptions] = useState<GptOptionsType>(
    defaultValue || 'basic',
  );
  const [loading, setLoading] = useState(defaultLoading);

  function requestUsedInfo() {
    setLoading(true);
    aigcAdvancedLimit()
      .then((data: any) => {
        const { maximum, remaining } = data || {};

        setTotal(maximum);
        setRemainder(remaining);
      })
      .catch(() => {
        setTotal(0);
        setRemainder(0);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (needRequest) {
      requestUsedInfo();
    }
  }, []);

  return {
    gptOptions,
    setGptOptions,
    remainder,
    total,
    loading,
    setRemainder,
  };
}
